import { AxiosResponse } from 'axios';

const PLANNING_ALGORITHM_ERROR_MESSAGE_VALUE =
  'В типе наряда не задан алгоритм распределения';

const DEFAULT_REQUEST_ERROR_MESSAGE =
  'Не удалось выполнить операцию. Попробуйте ещё раз.';

export const TASK_ASSIGNMENT_ERROR_MESSAGES: Record<string, string> = {
  DepartmentAssignmentError:
    'Не удалось автоматически назначить участок, назначьте участок вручную',
  planningAlgorithmError: PLANNING_ALGORITHM_ERROR_MESSAGE_VALUE
};

export const PLANNING_ALGORITHM_ERROR_MESSAGE =
  PLANNING_ALGORITHM_ERROR_MESSAGE_VALUE;

export function normalizeApiError(data: unknown): string | undefined {
  if (typeof data === 'string') return data;
  if (!data || typeof data !== 'object') return undefined;

  const record = data as Record<string, unknown>;
  if (typeof record.error === 'string') return record.error;
  if (typeof record.message === 'string') return record.message;
  if (typeof record.title === 'string') return record.title;

  return undefined;
}

export function getApiResponseErrorMessage(
  response: AxiosResponse<unknown> | undefined | null,
  defaultMessage: string = DEFAULT_REQUEST_ERROR_MESSAGE
): string | undefined {
  if (!response) return defaultMessage;

  const data = response.data as { isSuccess?: unknown } | undefined;
  const isFailedStatus = response.status >= 400;
  const isFailedBody = data?.isSuccess === false;

  if (!isFailedStatus && !isFailedBody) return undefined;

  const message = normalizeApiError(response.data);
  return message && message.trim().length > 0 ? message : defaultMessage;
}

export function getTaskAssignmentErrorMessage(
  data: unknown
): string | undefined {
  const error = normalizeApiError(data);
  if (isPlanningAlgorithmError(error)) {
    return PLANNING_ALGORITHM_ERROR_MESSAGE;
  }
  return error ? TASK_ASSIGNMENT_ERROR_MESSAGES[error] : undefined;
}

export function isPlanningAlgorithmError(data: unknown): boolean {
  const error = normalizeApiError(data);
  return (
    error === 'PlanningAlgorithmError' || error === 'planningAlgorithmError'
  );
}
